var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0801 20.9043H17.0801C17.6105 20.9043 18.1192 20.6936 18.4943 20.3185C18.8694 19.9434 19.0801 19.4347 19.0801 18.9043V5.9043L14.0801 0.904297H5.08008C4.54965 0.904297 4.04094 1.11501 3.66586 1.49008C3.29079 1.86516 3.08008 2.37386 3.08008 2.9043V5.9043M13.0801 0.904297V4.9043C13.0801 5.43473 13.2908 5.94344 13.6659 6.31851C14.0409 6.69358 14.5496 6.9043 15.0801 6.9043H19.0801M8.58008 16.4043L7.08008 15.1543V12.9043M13.0801 14.9043C13.0801 18.218 10.3938 20.9043 7.08008 20.9043C3.76637 20.9043 1.08008 18.218 1.08008 14.9043C1.08008 11.5906 3.76637 8.9043 7.08008 8.9043C10.3938 8.9043 13.0801 11.5906 13.0801 14.9043Z",
    stroke: "url(#paint0_linear_11837_6319)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11837_6319",
    x1: 19.0801,
    y1: 0.904297,
    x2: -2.20132,
    y2: 16.3968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileClock);
export default __webpack_public_path__ + "static/media/file-clock.67ab1eacd09011cd5dbaa5bf47dafffc.svg";
export { ForwardRef as ReactComponent };